import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import ReturnToStartScreenTimer from "../Common/ReturnToStartScreenTimer";
import OtherServicesClosed from "./OtherServicesClosed";
import PrintReceipt from "../Common/PrintReceipt";
import {ServiceCardType} from "../Types";
import {useTranslation} from "react-i18next";
import selfServiceRedux from '../../../Redux/selfServiceRedux'

interface QueueNumberProps {
    serviceCard: ServiceCardType
    queueNumber: number;
}

const QueueNumber = ({serviceCard, queueNumber}: QueueNumberProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [time, setTime] = useState<number|null>(null)

    const onPrintDone = () => {
        setTime(30)
    }

    useEffect(() => {
        dispatch(selfServiceRedux.setAllowClose(false))
    }, [dispatch]);

    return (<>
        {queueNumber >= 0 && <>
            <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={2} className="pageMainContainer">
                <Grid className="pageMainHeader">
                    <Typography variant="h4" gutterBottom>
                        {t('selfService.yourQueueNumberIs')}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant="h1" gutterBottom>
                        {queueNumber}
                    </Typography>
                </Grid>
                <Grid style={{textAlign: 'center'}}>
                    <Typography variant="subtitle1" gutterBottom>
                        {t('selfService.thankYou')}
                    </Typography>
                    <Typography variant="subtitle1"gutterBottom>
                        {t('selfService.pleaseWaitForYourTurn')}
                    </Typography>
                </Grid>
                <Grid>
                    <PrintReceipt serviceCard={serviceCard} type={"queueNumber"} onPrintDone={onPrintDone} />
                </Grid>
                <Grid style={{textAlign: 'center'}}>
                    {time !== null &&
                        <ReturnToStartScreenTimer time={time}/>
                    }
                </Grid>
                <Grid/>
            </Grid>
        </>}
        {queueNumber < 0 &&
            <OtherServicesClosed/>
        }
    </>)
};

export default QueueNumber;
